export default "__VITE_ASSET__BVxI1x9t__"